import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  className = 'MenuService';

  private _subject: Subject<any>;
  private _click: Subject<any>;
  menuChange: Observable<any>;
  clickChange: Observable<any>;

  constructor() {
    this._subject = new Subject<any>();
    this._click = new Subject<any>();
    this.menuChange = this._subject.asObservable();
    this.clickChange = this._click.asObservable();
  }

  notifyMenu(data: any) {
    this._subject.next(data);
  }

  notifyClick(data: any) {
    this._click.next(data);
  }

  getMenuPAI() {
    const json =
    {
      title: 'SIDEBAR.PLANNING.PAIS.NEW_PAI',
      data: [
        {
          title: 'SIDEBAR.PLANNING.PAIS.GENERAL_DATA',
          icon: 'icon icon-24-px-detalle white',
          roles: ['ROL_ADMINISTRADOR', 'ROL_DIRECTOR', 'ROL_FUNC_PAI','ROL_JEFE_DE_AREA'],
          component: 'general_data'
        },

        {
          title: 'SIDEBAR.PLANNING.PAIS.ACTIVITY',
          icon: 'icon icon-24-px-programa white',
          roles: ['ROL_ADMINISTRADOR','ROL_DIRECTOR', 'ROL_FUNC_PAI','ROL_JEFE_DE_AREA'],
          component: 'activity'
        },

        {
          title: 'SIDEBAR.PLANNING.PAIS.SUMMARY',
          icon: 'icon icon-24-px-comunicacion white',
          roles: ['ROL_ADMINISTRADOR','ROL_DIRECTOR', 'ROL_FUNC_PAI','ROL_JEFE_DE_AREA'],
          component: 'summary'
        }
      ],
      backNavigator: {
        title: "MENU.PLANNING",
        link: "pages/planning/pais"
      }
    }
    return json;
  }

  getDataMenuPAIPeriodClosed() {
    return [
      {
        title: 'SIDEBAR.PLANNING.PAIS.SUMMARY',
        icon: 'icon icon-24-px-comunicacion white',
        roles: ['ROL_ADMINISTRADOR','ROL_DIRECTOR', 'ROL_FUNC_PAI','ROL_JEFE_DE_AREA'],
        component: 'summary'
      }
    ]
  }

  getMenuBase() {
    const json =
    {
      title: 'SIDEBAR.PLANNING.TITLE',
      data: [

        {
          title: 'SIDEBAR.PLANNING.PAIS.TITLE',
          icon: 'icon icon-24-px-detalle white',
          roles: ['ROL_ADMINISTRADOR','ROL_DIRECTOR', 'ROL_FUNC_PAI', 'ROL_VALIDADOR','ROL_JEFE_DE_AREA'],
          link: '/pages/planning/dashboard/pais',
        },

        {
          title: 'SIDEBAR.PLANNING.WORKERS',
          icon: 'icon icon-24-px-plantilla white',
          roles: ['ROL_ADMINISTRADOR','ROL_DIRECTOR', 'ROL_FUNC_PREV_PLANTILLA', 'ROL_VALIDADOR'],
          link: '/pages/planning/dashboard/workers',
        },

        {
          title: 'SIDEBAR.PLANNING.BUDGET.TITLE',
          icon: 'icon icon-24-px-presupuestos white',
          roles: ['ROL_ADMINISTRADOR','ROL_DIRECTOR', 'ROL_FUNC_PRESUPUESTOS', 'ROL_VALIDADOR','ROL_JEFE_DE_AREA'],
          link: '/pages/planning/dashboard/budget',
        },
        {
          title: 'SIDEBAR.PLANNING.IDEAS.TITLE',
          icon: 'icon icon-24-px-ideas white',
          roles: ['ROL_ADMINISTRADOR','ROL_DIRECTOR', 'ROL_FUNC_IDEAS', 'ROL_VALIDADOR','ROL_JEFE_DE_AREA'],
          link: '/pages/planning/dashboard/ideas'
        }
      ]
    };

    return json;
  }

  getMenuBudget(id = undefined) {

    let json = {};
    if (!id) {
      json = {
        title: 'PRESUPUESTOS',
        data: [
          {
            title: 'SIDEBAR.PLANNING.BUDGET.DETAILS',
            icon: 'icon icon-24-px-detalle white',
            roles: ['ROL_ADMINISTRADOR','ROL_DIRECTOR', 'ROL_FUNC_PRESUPUESTOS','ROL_JEFE_DE_AREA'],
            link: '/pages/planning/new-budget/create',
            active: true
          },
        ],
        backNavigator: {
          title: "test",
          link: "pages/planning/pais"
        }
      }
    } else {
      json = {
        title: 'PRESUPUESTOS',
        data: [
          {
            title: 'SIDEBAR.PLANNING.BUDGET.DETAILS',
            icon: 'icon icon-24-px-detalle white',
            roles: ['ROL_ADMINISTRADOR','ROL_DIRECTOR', 'ROL_FUNC_PRESUPUESTOS','ROL_JEFE_DE_AREA'],
            link: `/pages/planning/budget/${id}/details/`,
            active: true
          },

          {
            title: 'SIDEBAR.PLANNING.BUDGET.TRACKING',
            icon: 'icon icon-24-px-programa white',
            roles: ['ROL_ADMINISTRADOR','ROL_DIRECTOR', 'ROL_FUNC_PRESUPUESTOS','ROL_JEFE_DE_AREA'],
            link: `/pages/planning/budget/${id}/tracking`,
          },
        ],
        backNavigator: {
          title: "test",
          link: "pages/planning/pais"
        }
      }
    }
    return json;
  }
  getMenuWorkers(id = undefined) {
    let json = {};
    if (id === undefined) {
      json = {
        title: 'WORKERS',
        data: [
          {
            title: 'PLANNING.WORKERS.DETAIL',
            icon: 'icon icon-24-px-detalle white',
            roles: ['ROL_ADMINISTRADOR','ROL_DIRECTOR', 'ROL_FUNC_PRESUPUESTOS'],
            link: '/pages/planning/new-workers/create',
            active: true
          },
        ],
        backNavigator: {
          title: "test",
          link: "pages/planning/pais"
        }
      }
    } else {
      json = {
        title: 'WORKERS',
        data: [
          {
            title: 'PLANNING.WORKERS.DETAIL',
            icon: 'icon icon-24-px-detalle white',
            roles: ['ROL_ADMINISTRADOR','ROL_DIRECTOR', 'ROL_FUNC_PRESUPUESTOS'],
            link: `/pages/planning/workers/${id}/details/`,
            active: true
          },
        ],
        backNavigator: {
          title: "test",
          link: "pages/planning/workers"
        }
      }
    }
    return json;
  }
  getMenuAspect(id = undefined) {

    let json = {};
    if (id === undefined) {
      json = {
        title: 'Aspectos',
        data: [
          {
            title: 'PLANNING.RELEVANT_ASPECTS.SIDEBAR.DETAILS',
            icon: 'icon icon-24-px-detalle white',
            roles: ['ROL_ADMINISTRADOR','ROL_DIRECTOR', 'ROL_FUNC_PRESUPUESTOS','ROL_JEFE_DE_AREA'],
            link: '/pages/management/new-aspect/create',
            active: true
          },
        ]
      }
    } else {
      json = {
        title: 'Aspectos',
        data: [
          {
            title: 'PLANNING.RELEVANT_ASPECTS.SIDEBAR.DETAILS',
            icon: 'icon icon-24-px-detalle white',
            roles: ['ROL_ADMINISTRADOR','ROL_DIRECTOR', 'ROL_FUNC_PRESUPUESTOS','ROL_JEFE_DE_AREA'],
            link: `/pages/management/aspects/${id}/details/`,
            active: true
          },
        ],
        backNavigator: {
          title: "test",
          link: "pages/management"
        }
      }
    }
    return json;
  }

  getMenuManagement() {
    const json =
    {
      title: 'SIDEBAR.MANAGEMENT.TITLE',
      data: [


        {
          title: 'SIDEBAR.MANAGEMENT.RELEVANT_ASPECTS.TITLE',
          icon: 'icon icon-24-px-comunicacion white',
          roles: ['ROL_ADMINISTRADOR','ROL_DIRECTOR', 'ROL_ADMINISTRADOR', 'ROL_JEFE_DE_AREA'],
          link: '/pages/management/relevant-aspects',
        },
        {
          title: 'SIDEBAR.MANAGEMENT.EXTERNAL_AUDIT',
          icon: 'icon icon-24-px-ideas white',
          roles: ['ROL_ADMINISTRADOR','ROL_DIRECTOR', 'ROL_ADMINISTRADOR', 'ROL_JEFE_DE_AREA', 'ROL_AUDITOR'],
          link: '/pages/management/external-audit',
        },
        {
          title: 'SIDEBAR.MANAGEMENT.DEAL_COMITTEE',
          icon: 'pi pi-users',
          roles: ['ROL_ADMINISTRADOR','ROL_DIRECTOR', 'ROL_ADMINISTRADOR', 'ROL_JEFE_DE_AREA'],
          link: '/pages/management/deal-comittee'
        }
      ]
    };

    return json;
  }
}

